/**
 * @file: AiEditionTabStack.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { AppNavigationProvider } from '@euler/app/components/AppNavigationProvider';
import { useStatusBarStyle } from '@euler/app/components/AppStatusBar';
import { spreadScreens } from '@euler/functions/spreadScreens';
import {
  WrappedNavigatorScreen,
  wrapNavigatorScreen,
} from '@euler/functions/wrapNavigatorScreen';
import { createStackNavigator } from '@react-navigation/stack';
import { memo } from 'react';

/**
 * A tab of the AI edition: a stack over existing pages, so a page that
 * replaces itself (the BI entry) does so inside the tab. Pages it does not
 * hold open over the tabs as before.
 */
export function aiEditionTabStack(
  title: string,
  screens: Record<string, WrappedNavigatorScreen<any>>,
  initialScreen: string,
) {
  const Stack = createStackNavigator();
  const Content = memo(() => {
    useStatusBarStyle('dark');
    return (
      <AppNavigationProvider>
        <Stack.Navigator
          initialRouteName={initialScreen}
          screenOptions={{ headerBackTitle: ' ' }}
        >
          {spreadScreens(Stack.Screen, screens, initialScreen)}
        </Stack.Navigator>
      </AppNavigationProvider>
    );
  });
  return wrapNavigatorScreen(() => <Content />, { title, headerShown: false });
}
